import cn from "classnames";
import { FC } from "react";
import Grid from "../Grid";
import type { CaseStudyStatsProps } from "./CaseStudyStats.types";
import { KeyIntegrationLogoList } from "./KeyIntegrationLogoList";

const CaseStudyStatsDesktop: FC<CaseStudyStatsProps> = ({
  industry,
  companySize,
  keyIntegrations,
  className,
}) => {

  const labelClassName = "text-micro1 uppercase text-gray-700";
  const valueClassName = "text-p1 font-500 text-gray-950";
  const statContainerClassName = "flex flex-col text-left gap-md col-span-4";

  return (
    <section
      className={cn("bg-white", className)}
    >
      <Grid className="w-full py-6">
        {/* Industry */}
        <div className={statContainerClassName}>
          <p className={labelClassName}>{industry.label}</p>
          <p className={valueClassName}>{industry.value}</p>
        </div>

        {/* Company size */}
        <div className={statContainerClassName}>
          <p className={labelClassName}>{companySize.label}</p>
          <p className={valueClassName}>{companySize.value}</p>
        </div>

        {/* Key integrations */}
        <div className={statContainerClassName}>
          <p className={labelClassName}>{keyIntegrations.label}</p>
          <KeyIntegrationLogoList logos={keyIntegrations.logos} />
        </div>
      </Grid>
    </section>
  );
};

export { CaseStudyStatsDesktop };
